import { LOCALES, PAGE_TYPES } from '../constants'
import { homePage, landingPage, simpleContentPage, authorPage } from '../controllers'
import { templates } from '../templates'
const { BASE_PATH } = process.env

const generatePageConfig = (slug) => {
  const fragments = [...slug]
  return {
    locale: (() => {
      if (LOCALES.has(fragments[0])) {
        return LOCALES.get(fragments.shift())
      }

      return LOCALES.get('gb')
    })(),
    pageType: (() => {
      if (PAGE_TYPES.has(fragments[0])) {
        if (PAGE_TYPES.get(fragments[0]) === PAGE_TYPES.get('ilp')) {
          return undefined
        }

        return PAGE_TYPES.get(fragments.shift())
      }

      if (fragments.length) {
        return PAGE_TYPES.get('ilp')
      }

      return PAGE_TYPES.get('hp')
    })(),
    ilpSlug: fragments
  }
}
export const getServerSideProps = async ({ req, query }) => {
  const host = req.headers.host
  const { slug = [] } = query
  const { locale, pageType, ilpSlug } = generatePageConfig(slug)
  switch (pageType) {
    case 'ilp': {
      return landingPage({ locale, ilpSlug, slug, host, query, baseUrl: BASE_PATH })
    }
    case 'cp': {
      return simpleContentPage({ pageSlug: slug.slice(-1)[0], locale, slug })
    }
    case 'hp': {
      return homePage({ locale, host })
    }
    case 'author': {
      const authorIdRegex = /^\d+/
      const id = ilpSlug.toString().match(authorIdRegex)
      if (id) {
        return authorPage({
          locale,
          authorId: id,
          page: query.page ? query.page : 1,
          baseUrl: BASE_PATH
        })
      }
    }
    default: {
      return {
        notFound: true
      }
    }
  }
}

const Index = ({ template, pageProps }) => {
  const Page = templates[template]
  return <Page {...pageProps} />
}

export default Index
